var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    className: "share_svg__design-iconfont"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.204 17.828-8.332-6.736a.829.829 0 0 0-1.35.644v4.48h-2.8a6.665 6.665 0 0 0-6.665 6.666V27.1a.829.829 0 0 0 1.487.504l.695-.908a7.27 7.27 0 0 1 5.773-2.851h1.51v3.942a.829.829 0 0 0 1.35.644l8.332-6.735a2.487 2.487 0 0 0 0-3.868Z",
    fill: "#D9DBDF",
    fillRule: "evenodd"
  })));
};
export default SvgShare;